import { render, staticRenderFns } from "./CommonTicketTable.vue?vue&type=template&id=3880a10c&"
import script from "./CommonTicketTable.vue?vue&type=script&lang=js&"
export * from "./CommonTicketTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports